"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Satellites = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Satellites = (function (_super) {
    __extends(Satellites, _super);
    function Satellites() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SATELLITES,
            tags: [Tags_1.Tags.SPACE],
            cost: 10,
            metadata: {
                cardNumber: '175',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1).slash().space().played;
                    });
                }),
                description: 'Increase your M€ production 1 step for each space tag your have, including this one.',
            },
        }) || this;
    }
    Satellites.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, 1 + player.getTagCount(Tags_1.Tags.SPACE), { log: true });
        return undefined;
    };
    return Satellites;
}(Card_1.Card));
exports.Satellites = Satellites;
//# sourceMappingURL=Satellites.js.map